export enum TaskReportGroup {
    None = 0,
    Completed = 1,
    Incomplete = 2,
    Missed = 3,
    Future = 4
}

export enum TaskReportStatus {
    Completed = 1,
    Submitted = 2,
    ExportReady = 3,
    Exported = 4,
    NotExported = 5,
    SentToPhysician = 6,
    Saved = 7,
    NotYetStarted = 8,
    Returned = 9,
    Reopened = 10,
    MissedVisit = 11,
    MissedVisitComplete = 12,
    MissedVisitPending = 13,
    MissedVisitReturn = 14,
    NotYetDue = 15
}
